import type { ManifestFragment } from "@/app/integration/contracts";

export const MATH_PATTERN_BRIDGE_LEVEL_ID = "math-pattern-bridge-1";
export const MATH_PATTERN_BRIDGE_PROMPT_AUDIO =
  "/audio/voice/math/pattern-bridge-1.ogg";

export const MATH_PATTERN_BRIDGE_MANIFEST: ManifestFragment = {
  owner: "domain-slice/math/math-pattern-bridge-1",
  requirements: [
    {
      path: MATH_PATTERN_BRIDGE_PROMPT_AUDIO,
      kind: "audio",
      levelIds: [MATH_PATTERN_BRIDGE_LEVEL_ID]
    }
  ]
};
